import aa from "search-insights";

type AlgoliaInsightsHit = {
    objectID?: string;
    __queryID?: string;
    __position?: number;
};

const indexName = import.meta.env.VITE_ALGOLIA_INDEX_PREFIX + "ALL_CONTENT";

export const addAlgoliaInsightsMetadata = <T extends AlgoliaInsightsHit>(
    hits: T[],
    queryID?: string,
) => {
    return hits.map((hit, index) => ({
        ...hit,
        __queryID: queryID,
        __position: index + 1,
    }));
};

export const trackAlgoliaSearchClick = (
    hit: AlgoliaInsightsHit,
    fallbackPosition?: number,
    eventName = "Search Result Clicked",
) => {
    const position = hit.__position ?? fallbackPosition;

    if (!hit.objectID || !hit.__queryID || !position) {
        return false;
    }

    aa("clickedObjectIDsAfterSearch", {
        index: indexName,
        eventName,
        objectIDs: [hit.objectID],
        positions: [position],
        queryID: hit.__queryID,
    });

    return true;
};
